// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es7.weak-set.from.js
// module id = 303
// module chunks = 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21